export default {
        'Brasil': {
            name: 'Brasil',
            currency: 'BRL',
            code: 'BRA',
            flag: 'bra.svg',
            lang: 'pt',
            phoneMasks: '+55 (##) ####-#####',
            phonePlaceholder: '+55 (00) 0000-0000',
            phoneMinLength: 18,
            index: 0,
            personalDocument: 'CPF',
            personalDocumentMask: '###.###.###-##',
            companyDocument: 'CNPJ',
            companyDocumentMask: '##.###.###/####-##',
            zipCodeMask: '#####-###'
        },
        'BRA': {
            name: 'Brasil',
            currency: 'BRL',
            code: 'BRA',
            flag: 'bra.svg',
            lang: 'pt',
            phoneMasks: '+55 (##) ####-#####',
            phonePlaceholder: '+55 (00) 0000-0000',
            phoneMinLength: 18,
            index: 0,
            personalDocument: 'CPF',
            personalDocumentMask: '###.###.###-##',
            companyDocument: 'CNPJ',
            companyDocumentMask: '##.###.###/####-##',
            zipCodeMask: '#####-###'
        },
        'Chile': {
            name: 'Chile',
            currency: 'CHI',
            code: 'CHI',
            flag: 'chi.svg',
            lang: 'es',
            phoneMasks: '+56 ## #-###-###',
            phonePlaceholder: '+56 00 0-000-000',
            phoneMinLength: 15,
            index: 1,
            personalDocument: 'RUN',
            personalDocumentMask: '##.###.###-#',
            companyDocument: 'RUT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '### ####'
        },
        'Colombia': {
            name: 'Colombia',
            currency: 'COL',
            code: 'COL',
            flag: 'col.svg',
            lang: 'es',
            phoneMasks: '+57 ##-########',
            phonePlaceholder: '+57 00-0000000',
            phoneMinLength: 15,
            index: 2,
            personalDocument: 'RUT',
            personalDocumentMask: '##.###.###-#',
            companyDocument: 'NIT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '######'
        },
        'Mexico': {
            name: 'Mexico',
            currency: 'MEX',
            code: 'MEX',
            flag: 'mex.svg',
            lang: 'es',
            phoneMasks: '+52 ### #######',
            phonePlaceholder: '+52 000 0000000',
            phoneMinLength: 15,
            index: 3,
            personalDocument: 'CURP',
            personalDocumentMask: 'AAAA######AAAAAA##',
            companyDocument: 'RUT',
            companyDocumentMask: '##.###.###-#',
            zipCodeMask: '#####'
        },
        'Peru': {
            name: 'Peru',
            currency: 'SOL',
            code: 'PER',
            flag: 'per.svg',
            lang: 'es',
            phoneMasks:  '+51 ### ### ###',
            phonePlaceholder: '+51 000 000 000',
            phoneMinLength: 14,
            index: 4,
            personalDocument: 'DNI',
            personalDocumentMask: '########-#',
            companyDocument: 'RUC',
            companyDocumentMask: '###########',
            zipCodeMask: '#####'
        },
        'PER': {
            name: 'Peru',
            currency: 'SOL',
            code: 'PER',
            flag: 'per.svg',
            lang: 'es',
            phoneMasks: '+51 ### ### ###',
            phonePlaceholder: '+51 000 000 000',
            phoneMinLength: 14,
            index: 4,
            personalDocument: 'DNI',
            personalDocumentMask: '#########',
            companyDocument: 'RUC',
            companyDocumentMask: '###########',
            zipCodeMask: '#####'
        }
}